import { render, staticRenderFns } from "./TopicsList.vue?vue&type=template&id=2a2532f8&scoped=true"
import script from "./TopicsList.vue?vue&type=script&lang=js"
export * from "./TopicsList.vue?vue&type=script&lang=js"
import style0 from "./TopicsList.vue?vue&type=style&index=0&id=2a2532f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a2532f8",
  null
  
)

export default component.exports